export const env = {
  DOMAIN_TO_SHARE_COOKIE: process.env.NEXT_PUBLIC_DOMAIN_TO_SHARE_COOKIE,
  MEDIA_URL: process.env.NEXT_PUBLIC_MEDIA_URL,
  MEDIA_USERNAME: process.env.NEXT_PUBLIC_MEDIA_USERNAME,
  MEDIA_PASSWORD: process.env.NEXT_PUBLIC_MEDIA_PASSWORD,
  CDN_URL: process.env.NEXT_PUBLIC_CDN_URL,
  CDN_AUTH_KEY: process.env.NEXT_PUBLIC_CDN_AUTH_KEY,
  SSO_URL: process.env.NEXT_PUBLIC_SSO_URL,
};
